import { useSelector } from "react-redux";
import { timeStampToNumberedDateString } from "../../../utils/commonServices";


export default (filesArray, sortQuery) => {
   // const userReducer = useSelector((state) => state.persistedReducers.userReducer);
    // console.log(filesArray)
   // const filesArray = userReducer.filtered_events;
    let sortedFiles=[]

        if (sortQuery == 'date_added'){
      const sorted = [...filesArray].sort((a, b) => a.startDate > b.startDate ? -1 : 1, );
   sortedFiles = sorted
    }
   
    if (sortQuery == 'start_dates'){
      const sorted = [...filesArray].sort((a, b) =>
    a.startDate > b.startDate ? -1 : 1,
   );
   sortedFiles = sorted
    }


if (sortQuery == 'end_dates'){
    const sorted = [...filesArray].sort((a, b) =>
  a.editor_start_date > b.editor_start_date ? -1 : 1,
 );
 sortedFiles = sorted
  }
    
if(sortQuery == 'a_z'){
  const sorted = [...filesArray].sort((a, b) =>
  a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
 );
 sortedFiles = sorted

  }

    if(sortQuery == "" || sortQuery == null){
      sortedFiles = [...filesArray]
    }

  
    return [sortedFiles];
  };